import { z } from 'zod'

export interface InventorySearch {
  q?: string
  categories?: string
  sort?: 'name' | 'quantity' | 'recent'
  /** A pallet's page links here filtered to it; see `palletFilterFromSearch`. */
  pallet?: string
  number?: number
}

export function validateInventorySearch(
  raw: Record<string, unknown>,
): InventorySearch {
  const categories =
    typeof raw.categories === 'string'
      ? [
          ...new Set(
            raw.categories
              .split(',')
              .map((v) => v.trim())
              .filter(Boolean),
          ),
        ]
      : []
  return {
    q:
      typeof raw.q === 'string' && raw.q.trim() && raw.q.length <= 200
        ? raw.q
        : undefined,
    categories: categories.length ? categories.join(',') : undefined,
    sort:
      raw.sort === 'name' || raw.sort === 'quantity' || raw.sort === 'recent'
        ? raw.sort
        : undefined,
    // Every key the route owns is returned, or the router drops it on the
    // first filter change and a pallet's deep link loses its filter.
    pallet: z.uuid().safeParse(raw.pallet).data,
    number: z.coerce.number().int().positive().safeParse(raw.number).data,
  }
}
